import type { LoadingSpinnerWrapperProps } from '@ad-lucy/components/shared/LoadingSpinner/types';
import { keyframes, styled } from '@ad-lucy/styled';

const Circle = styled.circle<{ color: string }>`
  fill: none;
  stroke: ${({ color }) => color};
  stroke-width: 2;
  opacity: 0.9;
`;

const InnerCircleKeyframes = keyframes`
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 67, 200;
      stroke-dashoffset: -29;
    }
    100% {
      stroke-dasharray: 67, 200;
      stroke-dashoffset: -93;
    }
`;

const OuterCircleKeyframe = keyframes`
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
`;

export const InnerCircle = styled(Circle)`
  animation: ${InnerCircleKeyframes} 1.5s ease-in-out infinite -0.5s;
`;

export const OuterCircle = styled(Circle)`
  animation: ${OuterCircleKeyframe} 1.5s ease-in-out infinite;
`;

export const LoadingSpinnerWrapper = styled.div<LoadingSpinnerWrapperProps>`
  ${({ absolute }) => {
    return absolute
      ? `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    `
      : 'width: 100%; height: 100%;';
  }};
  display: flex;
  align-items: center;
  justify-content: center;
`;
